import { useTranslation } from 'react-i18next';

import { useApproveQuotation } from '~/api/quotations';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  onClose: () => void;
  quotationId: number;
};

export const ApproveQuotationDialog = ({ onClose, quotationId }: Props) => {
  const { t } = useTranslation(['common', 'quotations']);

  const mutation = useApproveQuotation(quotationId);

  return (
    <AlertDialog.Body icon="CheckProgress" status="success">
      <AlertDialog.Title>{t('quotations:overview.allowModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('quotations:overview.allowModal.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Check"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => onClose(),
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('quotations:overview.rowActions.allow')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
